import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { animateScroll } from 'react-scroll';
import { StickyTray } from 'site-modules/shared/components/sticky-tray/sticky-tray';

import './back-to-top.scss';

const SCROLL_DURATION = 200;

export function BackToTop() {
  const [visible, setVisible] = useState(false);
  const scrollY = useRef(0);

  useEffect(() => {
    function handleWindowScroll() {
      setVisible(window.scrollY < scrollY.current && window.scrollY > window.innerHeight);
      scrollY.current = window.scrollY;
    }

    window.addEventListener('scroll', handleWindowScroll);

    return () => {
      window.removeEventListener('scroll', handleWindowScroll);
    };
  }, []);

  function handleClick() {
    animateScroll.scrollToTop({ duration: SCROLL_DURATION });
  }

  return (
    <StickyTray isSticky>
      <button
        className={classnames(
          'btn back-to-top d-flex flex-column align-items-center justify-content-around border-0 rounded bg-white ed-zdepth-6 fade ms-auto me-0_75 me-sm-2 mb-1_5 mb-lg-2 py-0_25 px-0',
          { show: visible }
        )}
        style={{
          width: '2.5rem',
          height: '4rem',
          margin: '0 0.75rem 1.5rem auto',
          padding: '0.25rem 0',
        }}
        onClick={handleClick}
        data-tracking-id="back_to_top"
        data-tracking-value="top"
      >
        <i
          className="icon icon-arrow-up8 text-primary-darker size-16"
          style={{ width: '1rem', height: '1rem' }}
          aria-hidden
        />
        <span className="visually-hidden">Scroll to&nbsp;</span>
        <span className="size-12 text-gray-darker">Top</span>
      </button>
    </StickyTray>
  );
}
